import Box from '@mui/material/Box';

import { escapeRegex, matchesSearchTerm } from './matchesSearchTerm';

interface HighlightedTextProps {
  searchTerm: string;
  text: string;
}

export default function HighlightedText({ searchTerm, text }: HighlightedTextProps) {
  const trimmedSearchTerm = searchTerm.trim();

  if (!trimmedSearchTerm || !matchesSearchTerm(text, trimmedSearchTerm)) {
    return text;
  }

  const searchRegex = new RegExp(`(${escapeRegex(trimmedSearchTerm)})`, 'gi');
  const parts = text.split(searchRegex);

  return parts.map((part, index) => {
    const partMatchesSearchTerm =
      part.toLocaleLowerCase() === trimmedSearchTerm.toLocaleLowerCase();

    if (!partMatchesSearchTerm) {
      return part;
    }

    return (
      <Box
        component="span"
        data-test-id="highlighted-text-match"
        key={`${part}-${index}`}
        sx={{
          bgcolor: 'warning.light',
          borderRadius: 0.25,
          color: 'inherit',
          px: 0,
        }}
      >
        {part}
      </Box>
    );
  });
}
